export const preventNegativePastInput = (e: React.ClipboardEvent<HTMLInputElement>) => {
	const parsedNumber = Number.parseFloat(e.clipboardData.getData('text/plain'));
	if (parsedNumber < 0) {
		e.preventDefault();
	}
};
